import { useMutation, useQueryClient } from "@tanstack/react-query";
import { couponsKeys } from "Api/Queries/Coupons/useCouponsQuery";
import { deleteCouponsCouponID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useDeleteCouponMutation = ({ onSuccess, onError }: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails((couponID: number) =>
      deleteCouponsCouponID(couponID),
    ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: couponsKeys.all });
      onSuccess?.();
    },
    onError,
  });
};
